const actionTypes = require('constants/actionTypes');
const Immutable = require('immutable');

const setInitialState = () => {
    return Immutable.Map().merge({
        showModal: false,
        callback: '',
        info: {
            titleTextKey: 'messagesScreen-preContractualErrorTitle',
            infoTextKey: 'messagesScreen-preContractualErrorText',
            buttonTextKey: 'button-tryagain',
        },
    });
};

const initialState = setInitialState();
const globalErrorModal = (state, action) => {
    state = state || initialState;
    switch (action.type) {
        case actionTypes.SHOW_GLOBAL_ERROR_MODAL:
            return state.merge({ ...state, showModal: action.data });
        case actionTypes.SET_CALLBACK_GLOBAL_ERROR_MODAL:
            return state.merge({ ...state, callback: action.data });
        case actionTypes.SET_INFO_GLOBAL_ERROR_MODAL:
            return state.merge({ ...state, info: action.data });
        default:
            return state;
    }
};

module.exports = globalErrorModal;
